/**
 * Removes a module from the current rack by sending a POST request to the API.
 * 
 * @param {object} module - The module to be removed. It should contain the properties required by the API.
 * @param {object} currentRack - The current rack from which the module will be removed. It should contain the properties required by the API.
 * @returns {Promise<Array>|null} - Returns a Promise that resolves to the list of ordered modules if the removal is successful, or null in case of an error.
 */
import toast from "react-hot-toast";

export const deleteModule = async (module, currentRack) => {
    try {
        const response = await fetch('https://d10xp9krdkfyts.cloudfront.net/api/deleteModule', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ currentRack: currentRack, module: module }),
        });

        const data = await response.json();

        if (data.status === 'success') {
            return data.ordered_modules;
        } else {
            toast.error(data.message);
            return null;
        }
    } catch (error) {
        toast.error('Unable to fetch data from server');
        console.error('Error:', error);
        return null;
    }
};

/**
 * Removes all modules with a specific part number from the current rack by sending a POST request to the API.
 * 
 * @param {object} currentRack - The current rack from which the modules will be removed. It should contain the properties required by the API.
 * @param {string} partNumber - The part number of the modules to be removed.
 * @returns {Promise<Array>|null} - Returns a Promise that resolves to the list of ordered modules if the removal is successful, or null in case of an error.
 */
export const deleteAllModule = async (currentRack, partNumber) => {
    try {
        const response = await fetch('https://d10xp9krdkfyts.cloudfront.net/api/deleteAllModules', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ currentRack: currentRack, PartNumber: partNumber }),
        });

        const data = await response.json();

        if (data.status === 'success') {
            return data.ordered_modules;
        } else {
            toast.error(data.message);
            return null;
        }
    } catch (error) {
        toast.error('Unable to fetch data from server');
        console.error('Error:', error);
        return null;
    }
};
